import { render, staticRenderFns } from "./dealerHotList.vue?vue&type=template&id=0a2884c8&scoped=true"
import script from "./dealerHotList.vue?vue&type=script&lang=js"
export * from "./dealerHotList.vue?vue&type=script&lang=js"
import style0 from "./dealerHotList.vue?vue&type=style&index=0&id=0a2884c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2884c8",
  null
  
)

export default component.exports